import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ProfileAPI } from "pages/profile/profile.service";
const initialState = {
  data: null,
  state: ""
};
export const usersSlice = createSlice({
  name: "holidays",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getHolidays.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getHolidays.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getHolidays = createAsyncThunk('Holidays/get', async(query) => {
  let data = await ProfileAPI.getHolidays();
  return data['holidays'];

});


export default usersSlice.reducer;